import React from 'react';
import _ from 'lodash';
import history from 'app/routes/history';
import HeaderThin from 'app/components/layout/HeaderThin';
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Badge,
} from 'reactstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SectionGroup from 'app/components/general/SectionGroup';
import Button from 'app/components/general/Button';
import Loader from 'app/components/general/Loader';
import { simpleDate } from 'app/utils/parsers';

import * as bulkImportsActions from 'app/ducks/bulkImports/actions';
import * as bulkImportsSelectors from 'app/ducks/bulkImports/selectors';

interface IReviewProps {
  appReady: boolean;
  actions: any;
  match: any;
  errors: any;
  bulkImports: any;
  connectionRuns: any;
  connections: any;
}

interface IReviewState {
  counter: number;
}

function selector(state): any {
  return {
    bulkImports: bulkImportsSelectors.getBulkImports(
      state,
    ),
  };
}

const actionCreators = _.merge(bulkImportsActions);

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class Review extends React.Component<
IReviewProps,
IReviewState
> {
  apiIntervals: any;

  static defaultProps: IReviewProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    errors: undefined,
    bulkImports: undefined,
  };

  state = {
    counter: 0,
  };

  componentDidMount = (): void => {
    this.props.actions.getBulkImport(
      this.props.match.params.bulkImportId,
    );
    this.apiIntervals = setInterval(() => this.pollBulkImport(), 10000);
  };

  componentWillUnmount = (): void => {
    clearInterval(this.apiIntervals);
  };

  // beginProcessing = (): void => {
  //   if (
  //     this.props.appReady
  //     && !this.props.bulkImports.isLoading
  //     && this.props.bulkImports.hasLoaded
  //     && !this.props.bulkImports.updatedBulkImport
  //     && this.props.bulkImports.currentBulkImport.status
  //       === 'pending'
  //   ) {
  //     const payload = {
  //       id: this.props.match.params.importId,
  //       status: 'processing',
  //     };
  //     this.props.actions.updateBulkImport(payload);
  //   }
  // };

  pollBulkImport = (): boolean => {
    // console.log('polling');
    if (
      this.state.counter < 10
      && !this.props.bulkImports.isLoading
      && this.props.bulkImports.currentBulkImport.status
        !== 'finished'
    ) {
      this.setState((previousState) => ({
        counter: previousState.counter + 1,
      }));
      this.props.actions.getBulkImport(
        this.props.match.params.bulkImportId,
      );
    }
    return true;
  };

  renderFullResults = (fullResults): React.ReactNode => {
    const results = [];

    if (fullResults === undefined) {
      return null;
    }
    results.push(<ListGroupItemHeading>Successful</ListGroupItemHeading>);
    const successResults = _.pickBy(fullResults, (result, key) => _.includes(_.toLower(key), 'success') || _.includes(_.toLower(key), 'unchanged'));
    const errorResults = _.pickBy(fullResults, (result, key) => _.includes(_.toLower(key), 'error'));
    const errorResultsCount = _.sum(_.values(errorResults));

    _.each(successResults, (value, key) => {
      if (value > 0) {
        results.push(
          <ListGroupItemText key={key}>
            {_.replace(_.startCase(key), 'Success', '')}
            {' '}
            <Badge color="green" pill>
              {value}
            </Badge>
          </ListGroupItemText>,
        );
      }
    });
    if (errorResultsCount > 0) {
      results.push(<ListGroupItemHeading>Failed</ListGroupItemHeading>);
      _.each(errorResults, (value, key) => {
        if (value > 0) {
          results.push(
            <ListGroupItemText key={key}>
              {_.replace(_.startCase(key), 'Error', '')}
              {' '}
              <Badge color="red" pill>
                {value}
              </Badge>
            </ListGroupItemText>,
          );
        }
      });
    }

    return results;
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <SectionGroup>
              <div className="row">
                <div className="col">
                  <ListGroup>
                    <ListGroupItem className="justify-content-between">
                      <ListGroupItemHeading>Import Type</ListGroupItemHeading>
                      <ListGroupItemText>
                        CSV
                      </ListGroupItemText>
                    </ListGroupItem>
                    <ListGroupItem className="justify-content-between">
                      <ListGroupItemHeading>Status</ListGroupItemHeading>
                      <div className="d-flex">
                        {this.props.bulkImports
                          .currentBulkImport.status !== 'processing'
                          && _.capitalize(
                            this.props.bulkImports
                              .currentBulkImport.status,
                          )}
                        <div className="d-inline-block inline-loader">
                          <Loader
                            className="d-block position-auto"
                            color="grey"
                            isActive={
                              this.props.bulkImports
                                .currentBulkImport.status !== 'finished'
                            }
                          />
                        </div>
                      </div>
                    </ListGroupItem>
                    <ListGroupItem className="justify-content-between">
                      <ListGroupItemHeading>Date Imported</ListGroupItemHeading>
                      <ListGroupItemText>
                        {simpleDate(
                          this.props.bulkImports
                            .currentBulkImport.createdAt,
                        )}
                      </ListGroupItemText>
                    </ListGroupItem>
                    {/* <ListGroupItem className="justify-content-between">
                      <ListGroupItemHeading>Results</ListGroupItemHeading>
                      <ListGroupItemText>
                        Successful
                        {' '}
                        <Badge pill>
                          {
                            this.props.bulkImports
                              .currentBulkImport.successCount
                          }
                        </Badge>
                      </ListGroupItemText>
                      <ListGroupItemText>
                        Failed
                        {' '}
                        <Badge pill color={this.props.bulkImports.currentBulkImport.failCount > 0 ? 'red' : 'grey'}>
                          {
                            this.props.bulkImports
                              .currentBulkImport.failCount
                          }
                        </Badge>
                      </ListGroupItemText>
                    </ListGroupItem> */}
                    <ListGroupItem className="justify-content-between">
                      {this.renderFullResults(
                        this.props.bulkImports.currentBulkImport
                          .importSummary,
                      )}
                    </ListGroupItem>
                    {/* <ListGroupItem className="justify-content-between">
                      <ListGroupItemHeading>
                        Import Identifier
                      </ListGroupItemHeading>
                      <ListGroupItemText>
                        {
                          this.props.bulkImports
                            .currentBulkImport.id
                        }
                      </ListGroupItemText>
                    </ListGroupItem> */}
                  </ListGroup>
                </div>
              </div>
              <div className="row with-margin-top">
                <div className="col btn-flex-group less-padding">
                  <div className="btn-flex-container">
                    <Button
                      className="btn-standard btn-2"
                      type="submit"
                      onClick={() => history.push('/team-members')}
                    >
                      See all team members
                    </Button>
                  </div>
                </div>
              </div>
            </SectionGroup>
          </div>
        </div>
      </div>
    );
  }
}
